import React, { type LinkHTMLAttributes, useRef } from 'react';

// This link is used to prevent default behaviour on drag
function Link({ children, ...props }: LinkHTMLAttributes<HTMLAnchorElement>) {
    const cursorClickPosition = useRef({ x: 0, y: 0 });
    const handleStartPosition = (e: React.PointerEvent) => {
        cursorClickPosition.current = { x: e.clientX, y: e.clientY}
    }
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if(
            Math.abs(cursorClickPosition.current.x - e.clientX) > 10
            || Math.abs(cursorClickPosition.current.y - e.clientY) > 10) {
            e.preventDefault();
        }
    }

    if(typeof props.href === "undefined") return <>{children}</>;

    return (<a
            {...props}
            onPointerDown={handleStartPosition}
            onClick={handleClick}
        >
            {children}
        </a>)
}

export default Link;